import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './error-pages.css';

export function Forbidden(): JSX.Element {
  useEffect(() => {
    document.title = '403 - Access Denied - Kibo Hub';
  }, []);

  return (
    <div className="error-page">
      <div className="error-content">
        <h1 className="error-code">403</h1>
        <h2 className="error-title">Access Denied</h2>
        <p className="error-description">
          You don't have permission to access this page. Please contact an administrator
          if you believe this is a mistake.
        </p>
        <div className="error-actions">
          <Link to="/" className="btn btn-primary">
            Go to Dashboard
          </Link>
          <button onClick={() => window.history.back()} className="btn btn-outline">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
